import { IShippingAddress } from './types'

export const checkAddressSufficient = (address?: IShippingAddress): boolean => (
  !!address && !!address.city && !!address.province && !!address.country
)
